import {CloseBurger, OpenBurger} from "../../animations/burgerMenu/burgerAnimation";
import {scrollStart, scrollStop} from "../../modules/lenis";

export default function BurgerMenu() {

    $('.c-burger').click(function () {
        if (!$(this).hasClass('js-isActive')) {
            $(this).addClass('js-isActive');
            $('.responsive__navbar').addClass('js-isActive');
            OpenBurger();
            scrollStop();

            TweenMax.fromTo($('.responsive__navbar'), .5, {transformOrigin: "top", scaleY: 0, ease: Power3.easeInOut,}, {transformOrigin: "top", scaleY: 1, ease: Power3.easeInOut});
            TweenMax.fromTo($('.responsive__navbar ul'), .5, {opacity: 0,}, {opacity: 1, delay: .4});

        } else {
            $(this).removeClass('js-isActive');
            $('.responsive__navbar').removeClass('js-isActive');
            CloseBurger();
            scrollStart();

            TweenMax.fromTo($('.responsive__navbar'), .5, {transformOrigin: "bottom", scaleY: 1, ease: Power3.easeInOut,}, {transformOrigin: "bottom", scaleY: 0, ease: Power3.easeInOut, delay: .4});
            TweenMax.fromTo($('.responsive__navbar ul'), .5, {opacity: 1,}, {opacity: 0,});
        }
    });
}

BurgerMenu();
